import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getData } from '@yme/api';
import { Col, Container, Row } from '@yme/atoms/grid';
import { InfoBlockEmptyResults } from '@yme/atoms/info-block-empty-results';
import { SpinnerLoader } from '@yme/atoms/spinner-loader';
import { AmbassadorCard } from '@yme/components/Destinations/Ambassadors/AmbassadorCard';
import { colMargins } from '@yme/components/Destinations/Ambassadors/AmbassadorCard/constants';
import { GET_AMBASSADORS_FOR_ROOT_PATH } from '@yme/components/Destinations/Ambassadors/constants';
import { IndentWrapper } from '@yme/components/Separator';
import { getRTL } from '@yme/selectors/common';
import { useTranslation } from '@yme/services/i18n';
export function AmbassadorsGrid({ experiencesRootPath, detailsPageUrl, isRemoveBottomIndent, }) {
    const [ambassadors, setAmbassadors] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const isRightToLeft = useSelector(getRTL);
    const { t } = useTranslation();
    useEffect(() => {
        if (!experiencesRootPath)
            return;
        const getPartnersByRoot = async () => {
            try {
                setIsLoading(true);
                const response = await getData(`${GET_AMBASSADORS_FOR_ROOT_PATH}${experiencesRootPath}`);
                const ambassadorsData = response.data?.ambassadorList?.items ?? [];
                setAmbassadors(ambassadorsData);
            }
            catch (error) {
            }
            finally {
                setIsLoading(false);
            }
        };
        getPartnersByRoot();
    }, [experiencesRootPath]);
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent, isRightToLeft: isRightToLeft },
        React.createElement(Container, { pt: "32px", lgPt: "48px" },
            React.createElement(Row, null, Boolean(ambassadors.length) ? (ambassadors.map((item, index) => {
                const isLast = index === ambassadors.length - 1;
                const marginProps = !isLast && colMargins;
                return (React.createElement(Col, { key: item.ambassadorName, ...marginProps },
                    React.createElement(AmbassadorCard, { data: item, detailsPageUrl: detailsPageUrl })));
            })) : (React.createElement(InfoBlockEmptyResults, { titleEmptyResults: t('destinations_noAmbassadorsFound_label'), descriptionEmptyResults: t('destinations_refreshPage_label'), isFullWidth: true })))),
        React.createElement(SpinnerLoader, { isLoading: isLoading, fullWidth: true })));
}
AmbassadorsGrid.displayName = 'AmbassadorsGrid_AEMComponent';
